import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";

const GenericModal = ({ hideModal, children }) => {
    const onOkClick = () => {
        hideModal();
    }

    return (
        <ModalHolder>
            <div style={{
                background: '#fff',
                position: 'relative',
                padding: '30px',
                maxWidth: '480px',
                width: '90%',
                boxSizing: 'border-box',
                textAlign: 'center',
                borderRadius: '15px',
                fontFamily: 'MTNRegular'
            }}>
                <div>
                    <div>
                        {children}
                    </div>
                </div>
            </div>
        </ModalHolder>
    )
}

const ModalHolder = ({ children }) => {
    return <div style={{
        position: 'absolute',
        zIndex: 100,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.7)'
    }}>
        <div style={{
            boxSizing: 'border-box',
            padding: '20px',
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {children}
        </div>
    </div>
}

const Button = styled.button`
    border-radius: 20px;
    border: ${({ borderColor }) => `2px solid ${borderColor}`};
    background-color: ${({ bgColor }) => `${bgColor}`};
    color: ${({ textColor }) => `${textColor}`};
    padding: 5px 10px;
    width: 100px;
    box-sizing: border-box;
    font-size: 14px;
`;

export default GenericModal;
